import ReactDOM from "react-dom";
import React, { useState } from "react";
import QRCode from "qrcode";
import * as $ from "jquery";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as moment from "moment";
import * as _ from "lodash";
import bootbox from "bootbox";

import { UiUtils } from "../../common/uiUtils";
import { ViewerUtils } from "../../common/viewerUtils";
import { ModelApi } from "../../api/modelApi";
import { viewerOptions, viewerState } from "../../viewer";
import * as SmartDrawings from "../../smartDrawings";
import { Misc } from "../../common/misc";
import { ShareUtils } from "./shareUtils";

enum SelectionType {
    Selected,
    Isolated,
    Hidden
}

interface ShareFormProps {
    viewer: Autodesk.Viewing.GuiViewer3D;
}

interface ShareFormState {
    shareId: string;
    lastShare: any;
    selectAll: boolean;
}

const CheckboxField = (props) => {
    return <div className="row">
        <label className="col-form-label col-10">{props.label}</label>
        <div className="col-auto form-check">
            <Field type="checkbox" className="form-check-input ml-0" name={props.name} checked={props.value} />
        </div>
    </div>;
}

class ShareForm extends React.Component<ShareFormProps, ShareFormState>  {
    private readonly maxObjectCount = Number.MAX_SAFE_INTEGER;
    private objectCount = 0;

    constructor(props) {
        super(props);

        this.state = {
            shareId: null,
            lastShare: null,
            selectAll: false
        };
    }

    labelWithCount = (label, arrayName) => {
        const array = _.get(this.state.lastShare, arrayName);

        const count = _.size(array);
        return count === 0 ? label : `${label} (${count})`;
    }

    render() {
        return (
            <Formik
                initialValues={{
                    position: true,
                    pivot: true,
                    selection: true,
                    isolation: true,
                    hidden: true,
                    comments: true,
                    measurements: true,
                    filters: true,
                    markup: true,
                    section: true,
                    env: true
            }}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(false);
                }}
                render={({ values, errors, status, touched, isSubmitting, handleReset, setValues }) => (
                    <Form className="container pt-3" style={{ width: "auto" }}>
                        <div className="row">
                            <div className="col">
                                <CheckboxField label="View orientation" name="position" value={values.position} />
                                <CheckboxField label="Pivot point" name="pivot" value={values.pivot} />
                                <CheckboxField label="Selected objects" name="selection" value={values.selection} /> 
                                <CheckboxField label="Isolated objects" name="isolation" value={values.isolation} />
                                <CheckboxField label="Hidden objects" name="hidden" value={values.hidden} />
                                <CheckboxField label={this.labelWithCount("Comments", "comments")} name="comments" value={values.comments} /> 
                                <CheckboxField label={this.labelWithCount("Measurements", "measurements")} name="measurements" value={values.measurements} />
                                <CheckboxField label={this.labelWithCount("Quick filters", "filters")} name="filters" value={values.filters} />
                                <CheckboxField label="Markup" name="markup" value={values.markup} />
                                <CheckboxField label="Section" name="section" value={values.section} />
                                <CheckboxField label="Lighting environment" name="env" value={values.env} />
                        </div>
                            <div className="col-md-auto">
                                <canvas id="qr-canvas" width={150} height={150}/>
                                </div>
                        </div>
                        <div className="form-group row">
                            <div className="col">
                            <button className="btn btn-sm btn-primary" type="button" onClick={
                                () => {
                                    const all: any = {};
                                    Object.keys(values).map(key => {
                                        all[key] = this.state.selectAll;
                                    });
                                    setValues(all);
                                    this.setState({ selectAll: !this.state.selectAll});
                                }
                            }>{this.state.selectAll ? "Select all" : "Deselect all"}</button>
                            </div>
                        </div>
                         <div className="form-group row">
                             <div className="col">
                                 <input id="urlField" className="form-control" type="text" readOnly={true} value={this.state.shareId != null ? ViewerUtils.viewShareUrl(this.state.shareId) : ""} />
                                 </div>
                         </div>
                        <button id="SmartDrawings.Share.Clipboard" type="button" className="btn btn-primary" onClick={() => this.copyToClipBoard(values)}>
                        Clipboard
                    </button>
                        <button id="SmartDrawings.Share.Qr" type="button" className="btn btn-primary ml-1" onClick={() => this.createQr(values)}>
                        QR Code
                    </button>
                        <button id="SmartDrawings.Share.Email" type="button" className="btn btn-primary ml-1" onClick={() => this.sendEmail(values)}>
                        Email
                    </button>
                </Form>
                )}/>
               
                
        );
    }

    private async copyToClipBoard(values) {
        const shareId = await this.createShare(values);
        if (!shareId) {
            UiUtils.notifyError("Saving share failed.");
            return;
        }

        this.setState({ shareId: shareId });
        const input = $("#urlField");
        input.select();
        (input[0] as any).setSelectionRange(0, 99999);
        document.execCommand("copy");
        UiUtils.notifySuccess("Link copied to clipboard.");
    }

    private async createQr(values) {
        const shareId = await this.createShare(values);
        if (!shareId) {
            UiUtils.notifyError("Saving share failed.");
            return;
        }

        this.setState({ shareId: shareId });
        QRCode.toCanvas(document.getElementById("qr-canvas"),
            ViewerUtils.viewShareUrl(shareId),
            err => {});

        const dataUrl = await QRCode.toDataURL(ViewerUtils.viewShareUrl(shareId));
        const a = document.createElement("a");
        a.href = dataUrl;
        const timestamp = moment().format("YYYYMMDD-HHmm");
        a.setAttribute("download", "SD-QR-" + timestamp + ".png");
        a.click();
    }

    private async sendEmail(values) {
        const shareId = await this.createShare(values);
        if (!shareId) {
            UiUtils.notifyError("Saving share failed.");
            return;
        }

        this.setState({ shareId: shareId });
        location.href = `mailto:?subject=${encodeURIComponent("SmartDrawings link")}&body=${
            encodeURIComponent(ViewerUtils.viewShareUrl(shareId))}`;
    }

    private getSelectedOrIsolatedOrHiddenNodes(selectionType: SelectionType) {
        var sel;
        switch (selectionType) {
            case SelectionType.Selected:
                sel = this.props.viewer.getAggregateSelection();
                break;
            case SelectionType.Isolated:
                sel = this.props.viewer.getAggregateIsolation();
                break;
            case SelectionType.Hidden:
                sel = this.props.viewer.getAggregateHiddenNodes();
                break;
            default:
                sel = [];
                UiUtils.notifyError("Unknown selection type for share");
                return [];
        }

        if (!_.isEmpty(sel)) {
            let nodes = [];
            for (let modelSel of sel) {
                const ids = selectionType === SelectionType.Selected ? modelSel.selection || modelSel.ids : modelSel.ids;
                const modelNodes = ids.map(s => {
                    if (viewerOptions.idMap.isEmpty()) {
                        return `${s}`;
                    } else {
                        const modelGuid = viewerOptions.idMap.modelGuid(modelSel.model.id);
                        return `${modelGuid}/${s}`;
                    }
                });
                nodes = [...nodes, ...modelNodes];
            }
            this.objectCount += nodes.length;
            if (this.objectCount > this.maxObjectCount) {
                UiUtils.notifyWarning(`${SelectionType[selectionType]} (${nodes.length} pcs) objects excluded from share.`);
                return null;
            }
            return nodes;
        }
        return [];
    }

    private makeSection() {
        const ext: any = this.props.viewer.getExtension("Autodesk.Section");
        if (ext == null) {
            return null;
        }
        const state = { cutplanes: [] };
        ext.getState(state);
        if (!_.isEmpty(state.cutplanes)) {
            for (let i = 0; i < state.cutplanes.length; i++) {
                state.cutplanes[i][3] = state.cutplanes[i][3] * viewerOptions.unitData.viewerToModelScale;
            }

            return {
                style: ext.getSectionStyle(),
                cutplanes: state.cutplanes
            };
        }
        return null;
    }

    private async createShare(values) {
        this.objectCount = 0;

        const { viewer } = this.props;

        const shareData: any = {
            queryId: viewerOptions.guid || viewerOptions.comboModelId,
            viewParameters: {
                posVector: values.position ? viewer.navigation.getPosition().toModelUnits().toSD() : null,
                pivotVector: values.pivot ? viewer.navigation.getPivotPoint().toModelUnits().toSD() : null,
                rotationQuaternion: values.position ? ViewerUtils.quaternionToObject(viewer.navigation.getCamera().quaternion) : null,
                selectedNodes: values.selection ? this.getSelectedOrIsolatedOrHiddenNodes(SelectionType.Selected) : null,
                isolatedNodes: values.isolation ? this.getSelectedOrIsolatedOrHiddenNodes(SelectionType.Isolated) : null,
                hiddenNodes: values.hidden ? this.getSelectedOrIsolatedOrHiddenNodes(SelectionType.Hidden) : null,
                lightingEnv: values.env ? (viewer.impl as any).currentLightPreset() + "" : null
            },
            comments: values.comments && !_.isEmpty(viewerState.comments) ? _.values(viewerState.comments) : null,
            measurements: values.measurements ? ShareUtils.measurementsFromExtension(viewer) : null,
            filters: values.filters && !_.isEmpty(viewerState.filters) ? _.values(viewerState.filters) : null,
            markups: values.markup && !_.isEmpty(viewerState.markups) ? _.values(viewerState.markups) : null,
            section: values.section ? this.makeSection() : null
        };
        try {
            if (_.isEqual(shareData, this.state.lastShare)) {
                return this.state.shareId;
            } else {
                this.setState({
                    lastShare: { ...shareData }
                });
                shareData.rcToken = await Misc.getRecaptchaToken("createShare");
                const resp = await ModelApi.createShare(shareData);
                UiUtils.notifySuccess("Share created.");
                return resp.data;
            }
        } catch (e) {
            console.log("Share failed", e);
        }
    }
}

class SharePanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, container: any, id: string, options?: any) {
        super(container, id, "Share", options);
        this.viewer = viewer;
        this.container.classList.add("share-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.contentDiv.classList.add("docking-panel-scroll");
        this.container.appendChild(this.contentDiv);
    }

    setVisible(show: boolean) {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<ShareForm viewer={this.viewer}/>, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }
}

export { SharePanel };